export const meetups = [
  {
    id: 'm1',
    title: 'Dev Web Conference',
    subtitle: 'Aprenda novas tecnologias e networking',
    description: 'Junte-se a nós na maior conferência de desenvolvimento web da cidade. Venha aprender com palestrantes experientes, conhecer pessoas novas e ampliar sua rede de contatos.',
    imageUrl: 'https://placehold.co/200x200',
    address: 'Avenida Paulista, 123',
    email: 'devwebconference@test.com'
  },
  {
    id: 'm2',
    title: 'Hackathon Web',
    subtitle: 'Uma competição para desenvolvedores',
    description: 'Venha participar da competição de programação mais intensa da cidade. Desenvolva soluções criativas e desafie outros desenvolvedores para ver quem tem a melhor solução. Muita diversão e prêmios para os vencedores!',
    imageUrl: 'https://placehold.co/200x200',
    address: 'Rua Augusta, 567',
    email: 'hackathonweb@test.com'
  },
  {
    id: 'm3',
    title: 'Web Design Workshop',
    subtitle: 'Melhore suas habilidades de design',
    description: 'Se você é um designer web iniciante ou experiente, este workshop é para você. Venha aprender novas técnicas e tendências de design e aplique diretamente em projetos. Traga seu laptop e prepare-se para criar designs incríveis!',
    imageUrl: 'https://placehold.co/200x200',
    address: 'Rua Oscar Freire, 1234',
    email: 'webdesignworkshop@test.com'
  },
  {
    id: 'm4',
    title: 'Meetup de React',
    subtitle: 'Venha aprender e compartilhar conhecimentos sobre React',
    description: 'Este é um encontro para quem usa ou quer começar a usar React. Venha aprender com outras pessoas experientes, compartilhar conhecimentos e projetos. Traga suas dúvidas e fique por dentro das novidades sobre esta tecnologia!',
    imageUrl: 'https://placehold.co/200x200',
    address: 'Avenida Faria Lima, 1000',
    email: 'reactmeetup@test.com'
  },
  {
    id: 'm5',
    title: 'Front-end Bootcamp',
    subtitle: 'Aprenda a desenvolver interfaces incríveis',
    description: 'Este bootcamp é para quem quer se tornar um especialista em front-end. Aprenda as melhores práticas de desenvolvimento web e as ferramentas mais populares. Além disso, participe de projetos práticos e construa seu próprio portfólio.',
    imageUrl: 'https://placehold.co/200x200',
    address: 'Avenida Brigadeiro Faria Lima, 1500',
    email: 'frontendbootcamp@test.com'
  },
  {
    id: 'm6',
    title: 'DevOps Meetup',
    subtitle: 'Conheça as melhores práticas de DevOps',
    description: 'Se você é um desenvolvedor que quer melhorar a eficiência do seu processo de desenvolvimento, este meetup é para você. Venha conhecer as melhores práticas de DevOps, aprenda a automatizar tarefas e integre seus processos de desenvolvimento. Além disso, você terá a oportunidade de conhecer outras pessoas que estão trabalhando com DevOps e trocar ideias sobre como melhorar sua prática.',
    imageUrl: 'https://placehold.co/200x200',
    address: 'Rua dos Pinheiros, 789',
    email: 'devopsmeetup@test.com'
  }
];